
import React from 'react';
import PivotTableUI from 'react-pivottable/PivotTableUI';
// // import 'react-pivottable/pivottable.css';
 import 'src/assets/css/pivottable.css';
import TableRenderers from 'react-pivottable/TableRenderers';
import Plot from 'react-plotly.js';
import createPlotlyRenderers from 'react-pivottable/PlotlyRenderers';
import Service from "src/api/Service";
import { Loading, Grid } from "@nextui-org/react";
import { aggregators } from 'react-pivottable/Utilities';
const PlotlyRenderers = createPlotlyRenderers(Plot);


class PivotTable extends React.Component {
    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        this.state = {
            tableData:[],
            defaultRows : [],
            defaultCols : [],
            isFetching:true,
            fieldsToShow:[],
            vals:[],
            hiddenFromAggregators:['Count'],  
            hiddenFromDragDrop:['KPI'],       
            aggregatorName:'',
            rendererName:'',
            countFilter:false,
        };

    
    }

   async fetchData(){
    
            var obj ={};
            const defaultfilterData = JSON.parse(localStorage.getItem("defaultfilterData"));
            obj['data']=defaultfilterData;
            obj['keyname']=this.props.prams.keyname;
            Service.post("dashboard/kpis",obj,(status,data)=>{   
          
            if(status==200){       
  
                var field= data['fieldsToShow'];
                var dataset= data['data'];
                  var finalSet=[];
                dataset.map(item=>{
                   var record={};
                   for (var key in field) {
                    // console.log(field);
                    var value = field[key];
                    // console.log(item);
                        record[value['sTitle']]= item[key]
                    };
                    finalSet.push(record);
                });

                this.setState({   
                    tableData: finalSet,       
                    fieldsToShow: field,    
                    defaultRows:data['defaultRows'], 
                    defaultCols:data['defaultCols'], 
                    hiddenFromDragDrop:data['hiddenFromDragDrop'],
                    vals:data['Vals'], 
                    aggregatorName:data['aggregatorName'], 
                    rendererName:data['rendererName'], 
                    // hiddenFromAggregators:data['hiddenFromAggregators'], 
                  isFetching: false,         
                });
            }
        })
    }


    async filterSummary(filterData){
      var url = "dashboard/kpis";
      var obj ={};
      obj['data']=filterData;
      obj['keyname']=this.props.prams.keyname;
        await Service.post(url,obj,(status,data)=>{
       
          if(status==200){       

              var field= this.state.fieldsToShow;
              var dataset= data['data'];
               var finalSet=[];
               if(dataset != null){
                dataset.map(item=>{
                  var record={};
                  for (var key in field) {
                   var value = field[key];
                       record[value['sTitle']]= item[key]
                   };
                   finalSet.push(record);
               });
               }

       
              this.setState({   
                  tableData: finalSet,                 
                isFetching: false,         
              });
          }
      })
  }

    chageFn(e){
        
        this.setState(e);
       
    }
  componentDidMount(){
    this.fetchData();

  }

  componentDidUpdate(){
    if(this.props.filterData.length == undefined  && this.state.countFilter != this.props.countFilter){
      this.setState({
        countFilter:this.props.countFilter,
        isFetching: true,         
      })
      this.filterSummary(this.props.filterData);
    }
  }


    render() {

        if(this.state.isFetching){
            return(<>
  
              <Grid.Container gap={2}>
              <Grid>
                <Loading  color="secondary" type="points-opacity" />
              </Grid>
            </Grid.Container>
                </>
            );
        }

        const plotlyOptions = {
          groupedColumn: true,
          responsive: true,
          showlegend: false,
          margin: {
            l: 50,
            r: 5,
            b: 60,
            t: 25,
          },
         
          yaxis: {
            title: this.props.prams.component, // set the y-axis title
          },
          xaxis: {
            title: "Months", // set the y-axis title
          },
        };

          
        const hiddenAttributes = ['List Unique Values', 'Average'];

        const renderers = Object.assign({}, PlotlyRenderers);
        Object.keys(renderers).forEach(key => {
          if (key !==this.state.rendererName) {
            delete renderers[key];
          }
        });

  
        Object.keys(aggregators).forEach(key => {
          if (key !==this.state.aggregatorName) {
            delete aggregators[key];
          }
        });
       

        return (
            <>
            <div className='row'>
              <div className='col-lg-5'>
                 <div className='componentNameC'>{this.props.prams.component}</div>
             </div>   
            </div>

            <div className="p-2">    
              <div className="row">       
              <div className='col-lg-12'>
              <PivotTableUI
                ref={this.myRef}
                rows={this.state.defaultRows} 
                cols={this.state.defaultCols}
                data={this.state.tableData}
                onChange={s => this.chageFn(s)}
                renderers={renderers}
                aggregators={aggregators}
                plotlyOptions={plotlyOptions}
                {...this.state}
            />
    
              </div>
    
    </div>
    </div>
        
        </>

            
        );
    }
}

export default PivotTable